export enum TransactionStatus {
  Available = "available",
  Completed = "completed",
  Expired = "expired",
  Canceled = "canceled",
}
